import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Link } from 'react-router-dom';

import ErrorBoundary from '../../containers/ErrorBoundary/ErrorBoundary';
import InputSearch from '../../containers/Learn/Search/InputSearch';
import { localeData } from '../../locales/data';
import { HOCPanel } from '../Panel/Panel';

import './Learn.scss';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { LEARN_PART_PATH_OPERATORS } from '../../shared/constants';
import analytics from '../../shared/services/analytics/analytics';
import { useLearnScope } from '../../containers/Learn/LearnScopeContext';

interface LearnReferencesProps {
  panelModifiers?: string[];
  showSearch?: boolean;
  asViewAll?: boolean;
  // The pathname where the current Learn Component it is been displayed
  // Eg : in this route /simulate the value is simulate, for the route /learn the value is learn
  path: string;
}

type LearnReferencesPropsGeneric = LearnReferencesProps & InjectedIntlProps;

const Panel = HOCPanel();

const LearnMainReferencesIntl = ({
  panelModifiers = [],
  showSearch = true,
  intl,
  asViewAll = true,
  path,
}: LearnReferencesPropsGeneric): JSX.Element => {
  const isSimulate = useLearnScope() === 'simulate';
  return (
    <div>
      <ErrorBoundary showUI={true} isNotFullScreen={true}>
        {showSearch && (
          <div className="learn-search-bar">
            <InputSearch modifiers={['medium']} hasCheckboxFilter={true} filterType="reference" path={path} />
          </div>
        )}
        <Panel
          title={intl.formatMessage({
            id: 'learnMainReferences.references',
            defaultMessage: localeData.en['learnMainReferences.references'],
          })}
          titleModifiers={['references']}
          panelModifiers={panelModifiers.concat(['learn'])}
          rightElem={
            asViewAll ? (
              <Link
                to={`/${path}/${LEARN_PART_PATH_OPERATORS}`}
                className="learn__header-link"
                onClick={() => {
                  analytics.trackCustomEvent(isSimulate ? 'sim_click_operator_view_all' : 'learn_click_operator_view_all');
                }}
              >
                <FormattedMessageHelper
                  tagName="span"
                  id="learnMainReferences.viewAll"
                  defaultMessage={localeData.en['learnMainReferences.viewAll']}
                />
              </Link>
            ) : null
          }
        >
          <div className="learn__box-container" data-testid="references-container">
            <div className="learn__box-row" style={{ overflowX: 'auto' }}>
              <Link
                to={'/learn/operators'}
                className="learn__box-link"
                onClick={() => {
                  analytics.trackCustomEvent(isSimulate ? 'sim_click_operator_list_view' : 'learn_click_operator_list_view');
                }}
              >
                <h2>
                  <FormattedMessageHelper id={'learnMainReferences.operators'} />
                </h2>
              </Link>
            </div>
          </div>
        </Panel>
      </ErrorBoundary>
    </div>
  );
};

export const LearnMainReferences = injectIntl(LearnMainReferencesIntl);
